import React, { Fragment } from 'react';
import Image from 'react-bootstrap/Image';
import CadeResourceIcons from '../CadeResource/CadeResourceIcons';

const CadeComponentDoodle = (props) => {
    // Images that can't be imported (because we are building their name dynamically) live in the public folder and are referenced relatively
    const doodle = "content/" + props.domainImage;
    return (
        <Fragment>
            <Image src={doodle} alt="Domain Name" fluid />
            <CadeResourceIcons
                resKey={props.resKey}
                resources={props.resources}
                clickHandler={props.resClickHandler}
                size={48}
            />
        </Fragment>
    );
}

export default CadeComponentDoodle;


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeComponentDoodle.js